'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Configuration = require('./configuration');
var InvoiceTemplate = require('./invoiceTemplate');
var Pack = require('./pack');
var Wallet = require('./wallet');
var Payment = require('./payment');
module.exports = /*#__PURE__*/function () {
  function WalletServiceApi(http) {
    _classCallCheck(this, WalletServiceApi);
    var walletClient = http.extend({
      serviceName: "wallet"
    });
    this._configuration = new Configuration(walletClient);
    this._invoiceTemplate = new InvoiceTemplate(walletClient);
    this._pack = new Pack(walletClient);
    this._wallet = new Wallet(walletClient);
    this._payment = new Payment(walletClient);
  }
  _createClass(WalletServiceApi, [{
    key: "setHttp",
    value: function setHttp(http) {
      this._configuration.setHttp(http);
      this._invoiceTemplate.setHttp(http);
      this._pack.setHttp(http);
      this._wallet.setHttp(http);
      this._payment.setHttp(http);
    }

    /**
    *
    * configuration
    *
    *  @returns {ConfigurationModel}
    */
  }, {
    key: "configuration",
    get: function get() {
      return this._configuration;
    }

    /**
    *
    * invoiceTemplate
    *
    *  @returns {InvoiceTemplateModel}
    */
  }, {
    key: "invoiceTemplate",
    get: function get() {
      return this._invoiceTemplate;
    }

    /**
    *
    * pack
    *
    *  @returns {PackModel}
    */
  }, {
    key: "pack",
    get: function get() {
      return this._pack;
    }

    /**
    *
    * wallet
    *
    *  @returns {WalletModel}
    */
  }, {
    key: "wallet",
    get: function get() {
      return this._wallet;
    }

    /**
    *
    * payment
    *
    *  @returns {PaymentModel}
    */
  }, {
    key: "payment",
    get: function get() {
      return this._payment;
    }
  }]);
  return WalletServiceApi;
}();